import styled from 'styled-components'

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const SettingsWrapper = styled.div`
  margin: 16px 0;
  padding: 0 16px;
  border-radius: 12px;
  ${props => `border: 1px solid ${props.theme._neo.ui01}`};
`

export const SettingsContainer = styled.div`
  ${props => props.noBorder ? '' : `border-top: 1px solid ${props.theme._neo.ui01};`}
  margin: 0 0 15px;
  padding: 5px 0 10px;
`

export const PresetTitle = styled.h2`
  font-size: 18px;
  margin: 24px 0 8px;
`

export const SettingsTitle = styled.h3`
  font-size: 18px;
  margin: 16px 0 8px;
`

export const SettingsDescription = styled.p`
  color: ${({ theme }) => theme._neo.textColor02};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`

export const StyledLegend = styled.legend`
  font-size: 14px;
  margin-bottom: 8px;
  padding: 0;
`

export const Participants = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`

export const AddParticipants = styled.div`
  margin-top: 15px;
`
